export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'aiqing', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-moon-line' },
  { slug: 'xiju', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-open-line' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-swap-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line' },
];

export const mangaList = [
  {
    slug: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '墨香',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga-style%20illustration%20of%20a%20mysterious%20curio%20shop%20at%20twilight%2C%20warm%20golden%20light%20spilling%20from%20dusty%20windows%2C%20antique%20items%20visible%20through%20glass%2C%20a%20young%20shopkeeper%20silhouette%20in%20the%20doorway%2C%20soft%20watercolor%20texture%2C%20Japanese%20manga%20cover%20art%20style%2C%20clean%20simple%20background%20with%20warm%20amber%20tones%2C%20elegant%20typography%20space%20at%20top&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    rating: 4.9,
    views: 1286000,
    chapters: 156,
    description: '平凡大学生林小天意外继承了一家神秘的杂货铺，店里每一件看似普通的商品都蕴含着不可思议的力量。在这里，他将遇到形形色色的顾客，经历一段段温暖又奇幻的故事。',
    featured: true,
    hot: true,
    latest: true,
    updateTime: '2026-08-04',
  },
  {
    slug: 'jianlai',
    title: '剑来',
    author: '烽火戏诸侯',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manga%20cover%20featuring%20a%20young%20swordsman%20in%20flowing%20white%20robes%20holding%20an%20ancient%20sword%2C%20mountain%20landscape%20with%20misty%20peaks%20behind%2C%20traditional%20ink%20wash%20painting%20style%2C%20dramatic%20clouds%2C%20golden%20accents%2C%20clean%20composition%20with%20simple%20background&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: 'xuanhuan',
    status: '连载中',
    rating: 4.8,
    views: 2560000,
    chapters: 320,
    description: '烽火戏诸侯经典小说改编漫画，讲述陈平安的修仙之路。天地有气，名为剑意，少年持剑入江湖。',
    featured: true,
    hot: true,
    latest: false,
    updateTime: '2026-08-03',
  },
  {
    slug: 'yirenzhixia',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20manga%20cover%2C%20a%20college%20student%20with%20mysterious%20glowing%20blue%20energy%20around%20his%20hands%2C%20urban%20cityscape%20background%20at%20night%2C%20neon%20lights%2C%20dynamic%20composition%2C%20Japanese%20shonen%20manga%20style%2C%20clean%20simple%20dark%20background%20with%20colorful%20highlights&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: 'dongzuo',
    status: '连载中',
    rating: 4.7,
    views: 3200000,
    chapters: 580,
    description: '随着父亲失踪，神秘少女冯宝宝找上张楚岚，平凡大学生被卷入异人世界的纷争之中。',
    featured: true,
    hot: true,
    latest: true,
    updateTime: '2026-08-05',
  },
  {
    slug: 'huyaoxiaohongniang',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20manga%20cover%20with%20a%20fox%20spirit%20girl%20with%20long%20flowing%20hair%20and%20fox%20ears%2C%20cherry%20blossom%20petals%20floating%2C%20traditional%20Chinese%20clothing%2C%20soft%20pink%20and%20golden%20color%20palette%2C%20dreamy%20atmosphere%2C%20shojo%20manga%20style%2C%20clean%20soft%20background&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: 'aiqing',
    status: '连载中',
    rating: 4.6,
    views: 1890000,
    chapters: 420,
    description: '涂山狐妖一族以红线仙为职业，为前世恋人牵线续缘。一段段跨越千年的爱情故事在此展开。',
    featured: false,
    hot: true,
    latest: false,
    updateTime: '2026-08-02',
  },
  {
    slug: 'doupocangqiong',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20cultivation%20manga%20cover%20showing%20a%20determined%20young%20warrior%20with%20flaming%20aura%20surrounding%20his%20body%2C%20ancient%20Chinese%20palace%20in%20background%2C%20dramatic%20fire%20and%20smoke%20effects%2C%20intense%20red%20and%20orange%20color%20scheme%2C%20action%20manga%20style%2C%20clean%20composition&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: 'rexue',
    status: '已完结',
    rating: 4.8,
    views: 5800000,
    chapters: 640,
    description: '这是一个斗气的世界，少年萧炎从天才陨落为废柴，在药老帮助下重新崛起的热血传奇。',
    featured: true,
    hot: false,
    latest: false,
    updateTime: '2026-06-15',
  },
  {
    slug: 'daomubiji',
    title: '盗墓笔记',
    author: '南派三叔',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20tomb-raiding%20adventure%20manga%20cover%2C%20dark%20underground%20tomb%20with%2C%20ancient%20Chinese%20artifacts%2C%20a%20flashlight%20beam%20cutting%20through%20darkness%2C%20eerie%20atmosphere%2C%20suspense%20thriller%20style%2C%20muted%20earthy%20tones%20with%20dramatic%20lighting%2C%20clean%20composition&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: 'xuanyi',
    status: '连载中',
    rating: 4.7,
    views: 4100000,
    chapters: 280,
    description: '五十年前一群长沙土夫子挖到一部战国帛书，残篇中记载了一座奇特的战国古墓的位置。',
    featured: false,
    hot: true,
    latest: true,
    updateTime: '2026-08-04',
  },
  {
    slug: 'quanzhigaoshou',
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20esports%20gaming%20manga%20cover%2C%20a%20cool%20male%20gamer%20with%20headphones%20and%20intense%20expression%2C%20digital%20game%20interface%20elements%20floating%20around%2C%20cyberpunk%20style%20with%20neon%20green%20and%20purple%20accents%2C%20clean%20dark%20background%2C%20sleek%20design&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: 'rexue',
    status: '已完结',
    rating: 4.9,
    views: 4500000,
    chapters: 500,
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，遭到俱乐部驱逐后重新崛起的故事。',
    featured: false,
    hot: false,
    latest: false,
    updateTime: '2026-05-20',
  },
  {
    slug: 'modaozushi',
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20cultivation%20danmei%20manga%20cover%2C%20two%20elegant%20male%20cultivators%20in%20flowing%20traditional%20robes%2C%20one%20in%20black%20and%20one%20in%20white%2C%20lotus%20flowers%20and%20ancient%20Chinese%20architecture%2C%20ink%20wash%20painting%20aesthetic%2C%20elegant%20composition%2C%20clean%20background&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: 'xuanhuan',
    status: '已完结',
    rating: 4.9,
    views: 6200000,
    chapters: 256,
    description: '魏无羡重生归来，与蓝忘机携手调查诡异事件，揭开前世今生的真相。墨香铜臭经典作品改编。',
    featured: false,
    hot: false,
    latest: false,
    updateTime: '2026-03-10',
  },
  {
    slug: 'zhenhunjie',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=A%20supernatural%20action%20manga%20cover%20featuring%20a%20guardian%20spirit%20warrior%20in%20ancient%20armor%20with%20modern%20street%20clothing%20mix%2C%20urban%20Chinese%20city%20at%20night%2C%20ghostly%20figures%2C%20dynamic%20battle%20pose%2C%20cool%20blue%20and%20white%20color%20scheme%2C%20shonen%20style&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: 'dongzuo',
    status: '连载中',
    rating: 4.6,
    views: 2900000,
    chapters: 380,
    description: '普通大学生夏铃误入罗刹街，结识了镇魂将曹焱兵，从此踏上了守护人灵两界和平的征程。',
    featured: false,
    hot: false,
    latest: true,
    updateTime: '2026-08-03',
  },
  {
    slug: 'shitaihua',
    title: '十载华年',
    author: '阿梗',
    cover: 'https://readdy.ai/api/search-image?query=A%20touching%20slice-of-life%20manga%20cover%20about%20school%20life%2C%20two%20teenagers%20standing%20under%20a%20cherry%20blossom%20tree%2C%20spring%20sunlight%20filtering%20through%20branches%2C%20warm%20pastel%20pink%20and%20cream%20colors%2C%20nostalgic%20Japanese%20school%20setting%2C%20gentle%20shojo%20manga%20style&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: 'xiaoyuan',
    status: '已完结',
    rating: 4.5,
    views: 980000,
    chapters: 120,
    description: '十年校园时光，一段从青涩到成熟的成长故事。青春的酸甜苦辣，友情的珍贵陪伴。',
    featured: false,
    hot: false,
    latest: false,
    updateTime: '2026-04-18',
  },
  {
    slug: 'anhechuanshuo',
    title: '暗河传说',
    author: '墨飞',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20horror%20manga%20cover%2C%20a%20mysterious%20figure%20standing%20at%20the%20edge%20of%20a%20dark%20river%2C%20ancient%20Chinese%20folklore%20monsters%20lurking%20in%20shadows%2C%20misty%20atmosphere%2C%20black%20and%20deep%20green%20color%20palette%2C%20eerie%20and%20beautiful&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: 'kongbu',
    status: '连载中',
    rating: 4.4,
    views: 1560000,
    chapters: 180,
    description: '暗河之下，藏着不为人知的秘密。一群探险者深入地下暗河，发现了一个古老而恐怖的世界。',
    featured: false,
    hot: false,
    latest: true,
    updateTime: '2026-08-01',
  },
  {
    slug: 'xiuluozhizhan',
    title: '修罗之斩',
    author: '九天',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20action%20manga%20cover%20showing%20a%20fierce%20warrior%20in%20battle%20armor%20swinging%20a%20giant%20blade%2C%20epic%20battlefield%20with%20explosions%2C%20dramatic%20orange%20and%20red%20energy%20waves%2C%20Chinese%20martial%20arts%20fantasy%20style%2C%20clean%20dynamic%20composition&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: 'rexue',
    status: '连载中',
    rating: 4.5,
    views: 870000,
    chapters: 95,
    description: '修罗界最强战士转世重生，带着前世记忆踏上复仇与守护之路。热血激战，燃爆全场！',
    featured: false,
    hot: false,
    latest: true,
    updateTime: '2026-08-04',
  },
];

export const chapters = [
  { number: 1, title: '第一话：奇妙的杂货铺', pages: 28, updateTime: '2026-01-15' },
  { number: 2, title: '第二话：第一位顾客', pages: 26, updateTime: '2026-01-22' },
  { number: 3, title: '第三话：神秘的镜子', pages: 30, updateTime: '2026-01-29' },
  { number: 4, title: '第四话：镜中的世界', pages: 24, updateTime: '2026-02-05' },
  { number: 5, title: '第五话：古老的怀表', pages: 28, updateTime: '2026-02-12' },
  { number: 6, title: '第六话：时间的秘密', pages: 32, updateTime: '2026-02-19' },
  { number: 7, title: '第七话：迷路的女孩', pages: 26, updateTime: '2026-02-26' },
  { number: 8, title: '第八话：月光下的约定', pages: 28, updateTime: '2026-03-04' },
  { number: 9, title: '第九话：不速之客', pages: 30, updateTime: '2026-03-11' },
  { number: 10, title: '第十话：黑暗中的光', pages: 24, updateTime: '2026-03-18' },
];

export const reputations = [
  {
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20person%20portrait%2C%20warm%20smile%2C%20simple%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    comment: '吹雪漫画网的阅读体验太好了！下拉式阅读流畅无比，画质高清，最重要的是真的无删减！强烈推荐《洞洞杂货铺》！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20portrait%20with%20glasses%2C%20gentle%20expression%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    comment: '每天必刷吹雪漫画网，更新速度快，漫画种类全。从热血到恋爱，从玄幻到悬疑，想看的这里都有！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20long%20hair%2C%20warm%20friendly%20smile%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    comment: '页面设计简洁大气，没有乱七八糟的广告，阅读很舒服。下拉式真的是漫画阅读的最佳方式！',
    rating: 4,
    date: '2026-07-20',
  },
  {
    name: '老李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle-aged%20Chinese%20man%20portrait%2C%20kind%20expression%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-04&orientation=squarish',
    comment: '跟着儿子一起看漫画，吹雪漫画网的分类做得很好，找漫画很方便。全家都爱看！',
    rating: 5,
    date: '2026-07-18',
  },
  {
    name: '嘉欣',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20short%20hair%2C%20bright%20smile%2C%20clean%20studio%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-05&orientation=squarish',
    comment: '收藏了十几部漫画在追，每天更新提醒很及时。吹雪漫画网是漫画爱好者的天堂！《洞洞杂货铺》超好看！',
    rating: 5,
    date: '2026-07-15',
  },
];

export const faqList = [
  {
    question: '吹雪漫画网的漫画都是免费的吗？',
    answer: '是的！吹雪漫画网所有漫画完全免费阅读，无需付费订阅，无隐藏收费，真正做到让每一位漫画爱好者都能畅享阅读乐趣。',
  },
  {
    question: '漫画是否无删减？',
    answer: '绝对无删减！我们坚持提供最完整的漫画内容，不进行任何删减或修改，让读者体验原汁原味的漫画作品。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种流畅的漫画阅读方式，您只需向下滑动页面即可连续观看所有漫画页面，无需逐页点击翻页。进入漫画章节后，页面会自动以长图形式展示所有内容，上下滑动即可轻松阅读。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '热门连载漫画通常每周更新1-2话，具体更新频率取决于原作进度。首页会实时显示最新更新的漫画，您也可以收藏喜欢的漫画获取更新提醒。',
  },
  {
    question: '移动端可以看漫画吗？',
    answer: '当然可以！吹雪漫画网采用响应式设计，完美适配手机和平板设备。无论您使用什么设备，都能享受流畅的下拉式漫画阅读体验。',
  },
  {
    question: '如何搜索想看的漫画？',
    answer: '您可以通过顶部导航栏的搜索框输入漫画名称进行搜索，也可以通过分类页面按类型浏览，或查看首页的热门推荐和最新更新来发现感兴趣的漫画。',
  },
];